import { Box, useTheme } from '@mui/joy';
import { useMediaQuery } from '@mui/material';
import { TopNavigation } from '../TopNavigation.jsx';
import { PAGE_MAX_WIDTH } from '@/theme.js';

export function HouseholdLayout({ children, addAction, fullWidth, backgroundColor = 'white', flushHeader }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100dvh', backgroundColor: backgroundColor === 'gray' ? 'var(--joy-palette-neutral-100)' : '#fff' }}>
      <TopNavigation addAction={addAction} fullWidth={fullWidth} />
      <Box
          component="main"
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            height: isMobile ? 'auto' : '100dvh',
            gap: 1,
            overflow: isMobile ? 'visible' : 'auto',
            // A page can bleed a background band across the whole window with
            // width: 100vw. That is a few pixels wider than the content area
            // whenever a vertical scrollbar is showing, so clip the sliver --
            // nothing in here is meant to scroll sideways, and without this the
            // overhang puts a stray horizontal scrollbar at the bottom.
            overflowX: 'clip',
            p: { xs: 2, md: 3 },
            pt: 2,
            pb: { xs: 9.625, md: 4 },
          }}
          // A sticky header wants to sit flush against the nav above it, but
          // `main` is also the scrolling container on desktop (overflow: auto),
          // so a sticky child can never be pulled up past this padding with a
          // negative margin -- the sticky spec clamps it to the padding edge.
          // The `p` shorthand above also wins the cascade over the `pt` in sx,
          // so an inline style is the only override that reliably reaches zero
          // here. flushHeader hands top spacing entirely to the page, at every
          // breakpoint, so the page's own header owns it instead.
          style={flushHeader ? { paddingTop: 0 } : undefined}
        >
          <Box sx={{
            maxWidth: fullWidth ? 'none' : PAGE_MAX_WIDTH,
            margin: '0 auto',
            minWidth: 0,
            width: '100%',
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
          }}>
            { children }
          </Box>
        </Box>
    </Box>
  );
}